// Global Instructions Rule Applied!

import { ActiveRecordsState, ActiveRecordsAction, RecordUsage } from '../../interfaces/active_records.ts'
import {
  SET_ACTIVE_RECORD,
  UPDATE_ACTIVE_RECORD,
  REMOVE_ACTIVE_RECORD,
  REGISTER_RECORD_USAGE,
  UNREGISTER_RECORD_USAGE
} from './constants.ts'
import { UPDATE_RECORD_BY_SEARCH } from '../../sync_engine/constants.ts'

const activeRecordsReducer = (
  state: ActiveRecordsState = {
    records: {},
    usage: {}
  },
  action: ActiveRecordsAction
): ActiveRecordsState => {
  switch (action.type) {
    case SET_ACTIVE_RECORD:
      const { uuid: setUuid, record } = action.payload
      return {
        ...state,
        records: {
          ...state.records,
          [setUuid]: record
        },
        usage: {
          ...state.usage,
          [setUuid]: state.usage[setUuid] || { drawer: false, fullForm: false }
        }
      }

    case UPDATE_ACTIVE_RECORD:
      const { uuid: updateUuid, updates } = action.payload
      const existingRecord = state.records[updateUuid]
      if (!existingRecord) {
        return state
      }
      return {
        ...state,
        records: {
          ...state.records,
          [updateUuid]: { ...existingRecord, ...updates }
        }
      }

    case REGISTER_RECORD_USAGE:
      const { uuid: registerUuid, context } = action.payload
      const currentUsage = state.usage[registerUuid] || { drawer: false, fullForm: false }
      return {
        ...state,
        usage: {
          ...state.usage,
          [registerUuid]: {
            ...currentUsage,
            [context]: true
          }
        }
      }

    case UNREGISTER_RECORD_USAGE:
      const { uuid: unregisterUuid, context: unregisterContext } = action.payload
      const unregisterCurrentUsage = state.usage[unregisterUuid]
      if (!unregisterCurrentUsage) {
        return state
      }

      const newUsage = {
        ...unregisterCurrentUsage,
        [unregisterContext]: false
      }

      const newUsageState = {
        ...state.usage,
        [unregisterUuid]: newUsage
      }

      const newRecords = { ...state.records }

      if (!newUsage.drawer && !newUsage.fullForm) {
        delete newRecords[unregisterUuid]
        delete newUsageState[unregisterUuid]
      }

      return {
        ...state,
        records: newRecords,
        usage: newUsageState
      }

    case REMOVE_ACTIVE_RECORD:
      const { uuid: removeUuid } = action.payload
      const removeUsage = state.usage[removeUuid]

      if (removeUsage && (removeUsage.drawer || removeUsage.fullForm)) {
        return state
      }

      const { [removeUuid]: removedRecord, ...remainingRecords } = state.records
      const { [removeUuid]: removedUsage, ...remainingUsage } = state.usage

      return {
        records: remainingRecords,
        usage: remainingUsage
      }

    case UPDATE_RECORD_BY_SEARCH: {
      const { searchField, searchValue, updates } = action.payload
      const updatedRecords = { ...state.records }

      Object.entries(state.records).forEach(([uuid, record]) => {
        if (record) {
          const recordValue = record[searchField]
          const matches = recordValue === searchValue || String(recordValue) === String(searchValue)

          if (matches) {
            const filteredUpdates = Object.keys(updates).reduce(
              (acc, key) => {
                if (key in record) {
                  acc[key] = updates[key]
                }
                return acc
              },
              {} as Record<string, any>
            )

            if (Object.keys(filteredUpdates).length > 0) {
              updatedRecords[uuid] = { ...record, ...filteredUpdates }
            }
          }
        }
      })

      return {
        ...state,
        records: updatedRecords
      }
    }

    default:
      return state
  }
}

export default activeRecordsReducer

export * from './active_record_actions.ts'
export * from './selectors.ts'
